module.exports = __webpack_public_path__ + "img/Picture16.43e3e3be.png";